var exports = {
  "B": "List__XCUflO",
};

module.exports = exports;
